import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'orderBy'
})
export class OrderByPipe implements PipeTransform {

  transform(items: any[], field: string, asc: boolean = true): any[] {
    if (items == null || field == null) {
      return items;
    }

    if (asc) {
      items.sort((a, b) => a[field] > b[field] ? 1 : -1);
    } else {
      items.sort((a, b) => a[field] < b[field] ? 1 : -1);
    }

    return items;
  }
}
